import { render } from "./BillUserImport.vue?vue&type=template&id=fb44efd4&ts=true"
import script from "./scripts/bill-user-import.ts?vue&type=script&lang=ts"
export * from "./scripts/bill-user-import.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__